


































import { Component, Vue } from "vue-property-decorator";
import { Observer } from "mobx-vue";
import { reaction } from "mobx";
import mapStore from "@/store/mapStore";
import format from "date-fns/format";
import { DATE_PICKER_FORMAT } from "@/Constants";
import { AddressSuggestionModel, getAddressGeocode } from "../../api/AddressLookup";
import notificationStore from "@/store/notificationStore";

@Observer
@Component
export default class MapAddressSearch extends Vue {
  mapStore = mapStore;
  maxDate = format(new Date(), DATE_PICKER_FORMAT);
  collectionDateMenu = false;
  dispose?: () => void;

  async mounted() {
    const disposeHandleUserTypedAddress = reaction(
      () => mapStore.userTypedAddress,
      (typedAddress: string) => {
        if (typedAddress && typedAddress.trim().length > 2) {
          mapStore.fetchAddressSuggestions(typedAddress.trim());
        } else {
          mapStore.clearAddressSuggestions();
        }
      }
    );

    const disposeHandleUserSelectedAddress = reaction(
      () => mapStore.userSelectedAddress,
      async (address: AddressSuggestionModel | null) => {
        //set this to undefined here, otherwise if the previous selected locatoin icon is hidden, it may flash again before flying to the new one
        mapStore.userSelectedAddressGeocode = null;
        try {
          if (address) {
            const response = await getAddressGeocode({
              addressLine1: address.addressLine1,
              unitNumber: address.unitNumber,
              houseNumber: address.houseNumber,
              streetName: address.streetName,
              suburb: address.suburb,
              postcode: address.postcode,
              city: address.suburb,
              state: address.state,
              country: address.countryCode,
              latitude: address.latitude,
              longitude: address.longitude
            });
            if (!response.geocode) {
              notificationStore.error("An unexpected error occurred while loading the address");
            } else {
              mapStore.userSelectedAddressGeocode = response.geocode;
            }
          }
        } catch (error) {
          notificationStore.error("An unexpected error occurred while loading the address");
        }
      }
    );

    this.dispose = () => {
      disposeHandleUserTypedAddress();
      disposeHandleUserSelectedAddress();
    };
  }

  getItemText(item: AddressSuggestionModel) {
    if (!item) return "";
    return `${item.addressLine1} ${item.suburb}`;
  }

  destroyed() {
    if (this.dispose) {
      this.dispose();
    }
  }
}
